import { NgModule } from '@angular/core';
import { BaseChartDirective } from './chart.directive';
var MDBChartsModule = (function () {
    function MDBChartsModule() {
    }
    return MDBChartsModule;
}());
export { MDBChartsModule };
MDBChartsModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    BaseChartDirective
                ],
                exports: [
                    BaseChartDirective
                ],
                imports: []
            },] },
];
/** @nocollapse */
MDBChartsModule.ctorParameters = function () { return []; };
//# sourceMappingURL=chart.module.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/charts/chart.module.js
// module id = ../../../../angular-bootstrap-md/charts/chart.module.js
// module chunks = 3